import {from} from 'rxjs';
import {map} from 'rxjs/operators';
import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import Group from './model';

export const fetchAllGroups = institutionId => {
    return from(RESTClient.getAuthenticated('v2/groups', {institutionId})).pipe(
        map(response => List(response).map(Group.fromAPI)),
    );
};

export const createGroup = (institutionId, title, suppressErrors = false) => {
    return from(RESTClient.postAuthenticated('daycare/group/new', {institutionId, title}, {suppressErrors}));
};
